import { valid, refreshToken, ajax, serviceAjax, header } from './base'
import config from '../../config'

const common= {
  async login(data = {}) {
    const response = await ajax({
      url: '/api/TokenAuth/Authenticate',
      type: 'post',
      data
    })
    return response
  },
  async loginOut(data = {}) {
    const response = await ajax({
      url: '/api/TokenAuth/LogOut',
      type: 'get',
      data
    })
    return response
  },
 
  async UploadGoodImg(data = {}) {
    const response = await serviceAjax({
      url: '',
      type: 'post',
      data,
      isFile:true
    })
    return response
  },

  
}
export default common



// WEBPACK FOOTER //
// ./src/common/api/common.js